import type { GridFilterModel } from '@mui/x-data-grid-pro';

export const isStringArray = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every((item) => typeof item === 'string');

export const isGridFilterModel = (
  value: unknown
): value is GridFilterModel => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'items' in value &&
    Array.isArray((value as GridFilterModel).items)
  );
};
